module.exports = __webpack_public_path__ + "static/media/right.e8f6caac.webp";